import styled from "styled-components/macro";
import {device} from "../../styles";

export const Root = styled.section`
    display: flex;
    flex-direction: column;
    gap: 15px;
    
    ${device.less1180} {
        gap: 10px;
        min-height: 40px;
    }
`;

export const Head = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    cursor: pointer;
    user-select: none;

    ${device.less1180} {
    }

    ${device.less768} {
        min-height: auto;
        cursor: default;
        padding: 0;
    }
`;

export const Title = styled.div`
    color: var(--color-accent);
    font-family: LatoWebSemibold, sans-serif;
    font-size: 14px;
    font-style: normal;
    line-height: 24px;
    text-transform: uppercase;
    
    ${device.less1180} {
        font-size: 12px;
    }

    &:after {
        content: " *";
    }
`;


export const Body = styled.div`
    transition: all 0.3s;
`;
